import { render, staticRenderFns } from "./Vet.vue?vue&type=template&id=779ce0d7&"
import script from "./Vet.vue?vue&type=script&lang=js&"
export * from "./Vet.vue?vue&type=script&lang=js&"
import style0 from "./Vet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports